import { useNavigate } from 'react-router-dom'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { useFinanceiroPage } from '@/hooks/useFinanceiroPage'
import { FinanceQueueSection } from '@/components/Financeiro/FinanceQueueSection'
import { FinanceStatsCards } from '@/components/Financeiro/FinanceStatsCards'
import { FinancePagamentosSection } from '@/components/Financeiro/FinancePagamentosSection'
import { FinanceiroTopbar } from '@/components/Financeiro/FinanceiroTopbar'
import {
  FinanceDataTable,
  financeTableHeadClass,
  financeTableRowClass,
} from '@/components/Financeiro/FinanceDataTable'

export default function Financeiro() {
  const navigate = useNavigate()
  const {
    tab,
    setTab,
    goToStatView,
    summary,
    requests,
    projects,
    loading,
    error,
    reload,
    formatFinanceStatus,
    openRequest,
    canManageQueue,
    projectFilter,
    setProjectFilter,
    queueLifecycle,
    setQueueLifecycle,
    queueStatus,
    setQueueStatus,
    queueType,
    setQueueType,
    queueSla,
    setQueueSla,
    queueAssignee,
    setQueueAssignee,
    queueUnassigned,
    setQueueUnassigned,
    queueSearch,
    setQueueSearch,
    queueArea,
    setQueueArea,
    assignees,
    typeOptions,
    typeLabelMap,
  } = useFinanceiroPage()

  const headClass = financeTableHeadClass()

  const openClienteFromProject = (empresaId: string, projectId: string) => {
    navigate(`/clientes/${empresaId}?tab=projetos&projeto=${projectId}&from=financeiro`)
  }

  return (
    <DashboardLayout title='Financeiro Agrada'>
      <FinanceiroTopbar
        tab={tab}
        setTab={setTab}
        loading={loading}
        onReload={() => void reload()}
        projectFilter={projectFilter}
        setProjectFilter={(v) => setProjectFilter(v as typeof projectFilter)}
      />

      {error && tab !== 'pagamentos' && (
        <div className='mb-4 rounded-lg border border-danger/30 bg-danger/5 px-4 py-3 text-sm text-danger'>
          {error}
        </div>
      )}

      {tab === 'pagamentos' ? (
        <FinancePagamentosSection />
      ) : loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : (
        <>
          {tab === 'dashboard' && summary && (
            <FinanceStatsCards summary={summary} onStatClick={goToStatView} />
          )}

          {tab === 'chamados' && (
            <FinanceQueueSection
              requests={requests}
              typeLabels={typeLabelMap}
              onOpenRequest={openRequest}
              canManageQueue={canManageQueue}
              queueLifecycle={queueLifecycle}
              setQueueLifecycle={setQueueLifecycle}
              queueSearch={queueSearch}
              setQueueSearch={setQueueSearch}
              queueStatus={queueStatus}
              setQueueStatus={setQueueStatus}
              queueArea={queueArea}
              setQueueArea={setQueueArea}
              queueType={queueType}
              setQueueType={setQueueType}
              queueSla={queueSla}
              setQueueSla={setQueueSla}
              queueAssignee={queueAssignee}
              setQueueAssignee={setQueueAssignee}
              queueUnassigned={queueUnassigned}
              setQueueUnassigned={setQueueUnassigned}
              assignees={assignees}
              typeOptions={typeOptions}
            />
          )}

          {tab === 'projetos' && (
            <FinanceDataTable>
              <table className='w-full text-sm'>
                <thead>
                  <tr className={headClass}>
                    <th className='px-4 py-3'>Projeto</th>
                    <th className='px-4 py-3'>Empresa</th>
                    <th className='px-4 py-3'>Status</th>
                    <th className='px-4 py-3'>Origem</th>
                  </tr>
                </thead>
                <tbody>
                  {projects.length === 0 ? (
                    <tr>
                      <td colSpan={4} className='px-4 py-10 text-center text-text-muted'>
                        Nenhum projeto financeiro ainda.
                      </td>
                    </tr>
                  ) : (
                    projects.map((p) => (
                      <tr
                        key={p.id}
                        className={financeTableRowClass(false)}
                        onClick={() => openClienteFromProject(p.empresa.id, p.id)}
                      >
                        <td className='px-4 py-3 font-medium'>{p.name ?? '—'}</td>
                        <td className='px-4 py-3'>{p.empresa.nome}</td>
                        <td className='px-4 py-3'>{formatFinanceStatus(p.status)}</td>
                        <td className='px-4 py-3 text-text-muted'>{p.source.replace(/_/g, ' ')}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </FinanceDataTable>
          )}
        </>
      )}
    </DashboardLayout>
  )
}
